import { defaultUserAccountData } from "Root/profile/components/AccountSettings/utils";
import { SET_ACCOUNT_LOADING, SET_USER_ACCOUNT, SET_ORIGINAL_USER_ACCOUNT_DATA, SET_COMMUNICATION_PREFS, } from "../actions/types";
const initialState = {
    loading: true,
    userAccount: { ...defaultUserAccountData },
    originalUserAccountData: { ...defaultUserAccountData },
    communicationPrefs: {
        email_opt_in: false,
        sms_opt_in: false,
    },
};
export default function accountSettingsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ACCOUNT_LOADING: {
            return {
                ...state,
                loading: action.payload,
            };
        }
        case SET_USER_ACCOUNT: {
            return {
                ...state,
                userAccount: action.payload,
            };
        }
        case SET_ORIGINAL_USER_ACCOUNT_DATA: {
            return {
                ...state,
                originalUserAccountData: action.payload,
            };
        }
        case SET_COMMUNICATION_PREFS: {
            return {
                ...state,
                communicationPrefs: action.payload,
            };
        }
        default:
            return state;
    }
}
